export default __webpack_public_path__ + "static/media/Kanipakam-slider-05@2x.c50928e2.png";